<template>
    <div class="py-5 sms-count-tab">
        <div class="px-6" v-if="smsCount.remain_balance">
            <h4 class="text-2xl font-bold mb-6">SMS Count</h4>
            <p class="mb-5">
                <span class="text-black font-bold pr-12 mr-3">Remaining Balance:</span>
                <span class="text-primary font-bold">${{ smsCount.remain_balance.price }}</span>
                <span class="text-sm mx-12 px-3">for</span>
                <span class="text-primary font-bold">{{ smsCount.remain_balance.sms }} SMS</span>
            </p>
            <div class="flex">
                <p class="text-black font-bold mr-12 pt-2">SMS Count:</p>
                <div>
                    <div class="flex align-center mb-6 pb-1">
                        <div class="flex-center date-filter">
                            <date-picker class="text-sm filter-date-picker" v-model="date_filter" @change="getSMSCountRemain" :format="date_format_string" range-separator="  to  " range type="date" :editable="false" :clearable="false" placeholder="From date to date"></date-picker>
                        </div>
                        <div class="text-sm view-by-select ml-4">
                            <v-select @input="changeSelectedFilter($event)" :value="selected_option" label="title" :options="filterOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                        </div>
                    </div>
                    <div class="flex justify-between mb-5">
                        <p class="flex align-center justify-between mr-2">
                            <span class="text-sm ml-3 sms-count-title">Sent</span>
                            <span class="text-primary-bold-center px-3 sms-count-number">
                            {{ smsCount.sms_count.send.sms }} SMS
                            </span>
                            <span>=</span>
                        </p>
                        <span class="text-primary-bold-center ml-base sms-count-price">
                            ${{ smsCount.sms_count.send.price }}
                        </span>
                    </div>
                    <!-- <div class="flex justify-between">
                        <p class="flex align-center justify-between mr-2">
                            <span class="text-sm ml-3 sms-count-title">Received</span>
                            <span class="text-primary-bold-center px-3 sms-count-number">
                            {{ smsCount.sms_count.received.sms }} SMS
                            </span>
                            <span>=</span>
                        </p>
                        <span class="text-primary-bold-center ml-base sms-count-price">
                            ${{ smsCount.sms_count.received.price }}
                        </span>
                    </div> -->
                    <vs-divider class="my-6 py-1"></vs-divider>
                    <div class="flex justify-between">
                        <p class="flex align-center justify-between mr-2">
                            <span class="text-sm ml-3 sms-count-title">Total</span>
                            <span class="text-primary-bold-center px-3 sms-count-number"></span>
                            <span></span>
                        </p>
                        <span class="text-primary-bold-center ml-base sms-count-price">
                            ${{ smsCount.sms_count.total }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <vs-divider class="opacity-0 my-12"></vs-divider>
        <div class="px-6">
            <div class="flex align-center justify-between mb-6">
                <h4 class="text-2xl font-bold">Reload History</h4>
                <div class="text-sm items-per-page-select" :style="`width: ${itemsPerPageSelectWidth}px`" v-if="smsHistory._meta.totalCount">
                    <v-select @input="changeItemsPerPage($event)" :value="itemsPerPage" :options="paginationOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false">
                        <template slot="option" slot-scope="option">
                            <div class="flex align-center justify-between" :class="{'font-bold' : itemsPerPage == option.label}">
                                <span>{{ option.label }}</span>
                                <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == option.label" />
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option" :value="option">
                            <div class="flex align-center">
                                <span>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ smsHistory._meta.totalCount - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : smsHistory._meta.totalCount }} of {{ smsHistory._meta.totalCount }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>
            <vs-table ref="table" :max-items="itemsPerPage" :data="smsHistory.items" class="reload-history-table">
                <template slot="thead">
                    <vs-th class="center-title text-center">#</vs-th>
                    <vs-th class="center-title text-center">DATE</vs-th>
                    <vs-th class="center-title text-center">PACKAGE</vs-th>
                    <vs-th class="center-title text-center">AMOUNT</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="text-center">{{ tr.package_code }}</vs-td>
                        <vs-td class="text-center">{{ tr.created_at }}</vs-td>
                        <vs-td class="text-center">{{ tr.package_sms }} SMS</vs-td>
                        <vs-td class="text-center">${{ tr.package_price }}</vs-td>
                    </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <div v-if="smsHistory._meta && smsHistory._meta.pageCount > 1" class="my-base">
                <custom-pagination
                    :totalPages="parseInt(smsHistory._meta.pageCount)"
                    :currentPage="currentPage"
                    @pageChanged="changePage"
                    :key="'reload-pag-' + page_key"
                ></custom-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { formatDateString } from '../../helper/datetimeHelper';
import moment from 'moment';
export default {
    name: "sms-count-tab",
    components: { DatePicker, vSelect },
    data() {
        let date_format_string = formatDateString();
        let filterOptions = [];
        let selected_option = {
            id: 1,
            title: 'Day',
            type: 'day',
            start_date: new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1),
            end_date: new Date()
        };
        filterOptions = this.getFilterOptions();
        return {
            paginationOptions: [10, 15, 20, 30],
            page_key: 0,
            currentPage: 1,
            itemsPerPage: 10,
            loaded_data_num: 0,
            date_filter: [new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1), new Date()],
            filterOptions,
            selected_option,
            date_format_string
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if (this.loaded_data_num >= 2) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get";
                    this.openLoadingInDiv();
                }
            },
        },
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#app",
                scale: 0.8,
            });
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout(() => {
                if (this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: "danger",
                        title: "Notification",
                        text: this.action_type + " sms balance failed",
                        acceptText: "OK",
                    });
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close("#app > .con-vs-loading");
            this.isOpenLoading = false;
        },
        getFilterOptions() {
            let filterOptions = [];
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Day',
                type: 'day',
                start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                end_date: new Date()
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Week',
                type: 'week',
                start_date: moment().startOf('isoweek').toDate(),
                end_date: new Date()
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Month',
                type: 'month',
                start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                end_date:  new Date()
            });
            filterOptions.push({
                id: filterOptions.length + 1,
                title: 'Year',
                type: 'year',
                start_date: new Date(new Date().getFullYear(), 0, 1),
                end_date:  new Date()
            });
            return filterOptions;
        },
        getReloadHistory() {
            this.openLoadingInDiv();
            const obj = {
                page: this.currentPage,
                "per-page": this.itemsPerPage,
            };
            this.$store.dispatch("smsCount/GET_SMS_RELOAD_HISTORY", obj).then(() => {
                this.closeLoading();
            });
        },
        changePage(currentPage) {
            this.currentPage = currentPage;
            this.page_key++;
            this.getReloadHistory();
        },
        changeItemsPerPage(itemsPerPage) {
            this.itemsPerPage = itemsPerPage;
            this.changePage(1);
        },
        getSMSCountRemain() {
            if(this.date_filter && this.date_filter.length > 0) {
                let obj = {
                    from: moment(this.date_filter[0]).format('YYYY-MM-DD'),
                    to: moment(this.date_filter[1]).format('YYYY-MM-DD')
                }
                this.openLoadingInDiv();
                this.$store.dispatch("smsCount/GET_SMS_COUNT_REMAIN", obj).then(() => {
                    this.closeLoading();
                })
            }
        },
        changeSelectedFilter(e) {
            this.selected_option = e;
            this.date_filter = [this.selected_option.start_date, this.selected_option.end_date];
            this.getSMSCountRemain();
        },
    },
    computed: {
        smsCount() {
            return this.$store.getters["smsCount/smsRemain"];
        },
        smsHistory() {
            return this.$store.getters["smsCount/smsCountHistory"];
        },
        itemsPerPageSelectWidth() {
            let smsHistory = this.$store.getters["smsCount/smsCountHistory"];
            let first_num = this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
            let second_num = 0;
            let third_num = 0;
            if(smsHistory._meta && smsHistory._meta.totalCount) {
                second_num = smsHistory._meta.totalCount - this.currentPage * this.itemsPerPage > 0 ? this.currentPage * this.itemsPerPage : smsHistory._meta.totalCount;
                third_num = smsHistory._meta.totalCount;
            }
            return (('' + first_num + second_num + third_num).length + 6) * 12;
        }
    },
    created() {
        let obj = {
            from: moment(this.date_filter[0]).format('YYYY-MM-DD'),
            to: moment(this.date_filter[1]).format('YYYY-MM-DD')
        }
        this.$store.dispatch("smsCount/GET_SMS_COUNT_REMAIN", obj).then(() => {
            this.loaded_data_num++;
        });
        let history_obj = {
            page: this.currentPage,
            "per-page": this.itemsPerPage
        }
        this.$store.dispatch("smsCount/GET_SMS_RELOAD_HISTORY", history_obj).then(() => {
            this.loaded_data_num++;
        });
    },
}
</script>